import { useQuery } from '@tanstack/react-query';
import { fetchCompanySettings } from '../api/resources';
import { useAuth } from '../context/AuthContext';

/**
 * Company switches that change what a screen may show. One place, so the
 * Orders screen and the rates screen always tell the same story.
 */
export function useCompanySettings() {
  const { companyId, currentCompany } = useAuth();
  const { data, isLoading } = useQuery({
    queryKey: ['company-settings', companyId],
    queryFn: () => fetchCompanySettings(companyId),
    enabled: !!companyId,
  });
  const company = data?.company || currentCompany?.company || null;
  return {
    company,
    isLoading,
    // Off: every job is paid the item's standard cutting / stitching rate, and
    // no per-worker rate is offered anywhere.
    workerWiseRates: !!company?.enableWorkerWiseRates,
    gstEnabled: !!company?.gstEnabled,
    // On: one cutting master cuts the whole order. Off: each garment's
    // cutting is handed out on its own row. Default on while the setting is
    // still loading, so the screen never flickers through the other layout.
    singleCuttingMaster: company ? !!company.singleCuttingMaster : true,
  };
}
